import { render } from "./ContactTextArea.vue?vue&type=template&id=375b8d63&scoped=true"
import script from "./ContactTextArea.vue?vue&type=script&lang=js"
export * from "./ContactTextArea.vue?vue&type=script&lang=js"

import "./ContactTextArea.vue?vue&type=style&index=0&id=375b8d63&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375b8d63"]])

export default __exports__